import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '@environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class MagazinesApiService {

  constructor(
    private http: HttpClient,
  ) { }

  getMagazines(filter: any): Observable<any> {
    return this.http.get(`${environment.URL_API_AV}/api/doctrine/web/magazines`, { params: filter });
  }

}
